/**
 * Shows the warning of the chosen user type (nanny, childminder) and hides the others; markup in
 * templates/Auth/partials/user_type_options.html.twig.
 */
export const initUserTypeWarnings = (container: HTMLElement) => {
  const userTypeRadios = container.querySelectorAll<HTMLInputElement>('input[name="user_type"]');
  const warningMessages = container.querySelectorAll<HTMLDivElement>(
    "[data-user-type-warning-message]",
  );

  userTypeRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      const target = radio.dataset.userTypeWarning;
      warningMessages.forEach((message) => {
        message.classList.toggle("d-none", message.dataset.userTypeWarningMessage !== target);
      });
    });
  });
};

/**
 * No user type is preselected: submitting without a choice shows the partial's message above the
 * options instead of the browser's validation bubble. The message goes once an option is chosen.
 */
export const initUserTypeRequired = (form: HTMLFormElement) => {
  form.noValidate = true;

  const error = form.querySelector<HTMLDivElement>("[data-user-type-error]");
  const userTypeRadios = form.querySelectorAll<HTMLInputElement>('input[name="user_type"]');

  userTypeRadios.forEach((radio) => {
    radio.addEventListener("change", () => error?.classList.add("d-none"));
  });

  // Capture phase: runs before initFormValidation()'s handler, which then sees the cancelled
  // submit and leaves the button alone instead of showing its spinner
  form.addEventListener(
    "submit",
    (event) => {
      if (form.querySelector('input[name="user_type"]:checked')) {
        return;
      }

      event.preventDefault();
      error?.classList.remove("d-none");
      error?.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    { capture: true },
  );
};
